import $ from 'jquery';
import { Switchboard } from '../../../../events';
export class ColorizeMenuUI {
    constructor() {
        this.receiver = Switchboard.get_receiver('CONTEXT');
        this.base = $('#colorize-dialog');
        this.fields = $("#colorize-field");
        this.number = $("#colorize-numcolors");
        this.gradient = $("#colorize-gradient");
        this.start_color = $("#colorize-startcolor");
        this.end_color = $("#colorize-endcolor");
        this.strategies = $("#colorize-strategy");
        this.opacity = $("#colorize-opacity");
        this.receiver.on('ctx_change', () => this.hide());
    }
    show() {
        this.base.removeClass('hidden');
    }
    hide() {
        this.base.addClass('hidden');
        this.fields.empty();
        this.strategies.empty();
    }
    bind_to(manager) {
        this.fields.on('change', (event) => {
            manager.fields.select(event.target.value);
            manager.generate_gradient();
        });
        this.number.val(manager.color_range.steps).on('change', (event) => {
            manager.color_range.steps = Number(event.target.value);
            manager.generate_gradient();
        });
        this.gradient.prop('checked', false).change((event) => {
            manager.set_gradient(event.target.checked);
            manager.populate_strategies();
            manager.generate_gradient();
        });
        this.start_color.val(manager.color_range.start).on('change', (event) => {
            manager.color_range.start = event.target.value;
            manager.generate_gradient();
        });
        this.end_color.val(manager.color_range.end).on('change', (event) => {
            manager.color_range.end = event.target.value;
            manager.generate_gradient();
        });
        this.strategies.val(manager.strategy.map(s => s.name).unwrapOr('')).on('change', (event) => {
            const strategy_name = event.target.value;
            manager.set_strategy(strategy_name);
            manager.generate_gradient();
        });
        this.opacity.val(manager.color_range.opacity).on('change', (event) => {
            manager.color_range.opacity = Number(event.target.value);
            manager.generate_gradient();
        });
        return this;
    }
    update_field_names(field_names, selected) {
        this.fields.empty();
        for (let field of field_names) {
            $('<option />').val(field).text(field).appendTo(this.fields);
        }
        selected.map(f_name => this.fields.find(`option[value='${f_name}']`).prop('selected', 'selected').change());
    }
    update_strategies(strategies, selected) {
        this.strategies.empty();
        for (let s of strategies) {
            $('<option />').val(s.name).text(s.name).appendTo(this.strategies);
        }
        selected
            .map(strat => strat.name)
            .map(name => {
            this.strategies.find(`option[value='${name}']`).prop('selected', 'selected').change();
        });
    }
}
